import React, { memo } from "react";
import { formats } from "investira.sdk";
import { Box, Stack, Typography } from "investira.react.components";

import { CardInfo } from "../../../components/molecules";

const AtivoIndicadores = memo((props) => {
  const { cotacao, ativo, pessoa } = props;

  if (process.env.NODE_ENV === "production") {
    return null;
  }

  if (!["ACN", "CTIM"].includes(ativo.ativo_tipo_id)) {
    return null;
  }

  const indicadoresFinanceiros = [
    { indicador: "P/L", valor: 5.05 },
    { indicador: "P/Receita (PSR)", valor: 0.61 },
    { indicador: "P/VP", valor: 0.91 },
    {
      indicador: "Dividend Yield",
      valor: 0.0887,
      variant: "percentual",
    },
    { indicador: "Payout", valor: 0.4428, variant: "percentual" },
    { indicador: "Margem Líquida", valor: 0.1216, variant: "percentual" },
    { indicador: "Margem Bruta", valor: 0.3634, variant: "percentual" },
    { indicador: "Margem EBIT", valor: 0.1545, variant: "percentual" },
    { indicador: "EV/EBIT", valor: 3.98 },
    { indicador: "P/EBIT", valor: 3.98 },
    { indicador: "P/Ativo", valor: 0.07 },
    { indicador: "P/Cap.Giro", valor: 0.21 },
    { indicador: "P/Ativo Circ Liq", valor: -0.11 },
    { indicador: "VPA", valor: 31.21 },
    { indicador: "LPA", valor: 5.64 },
    { indicador: "Giro Ativos", valor: 0.11 },
    { indicador: "ROE", valor: 0.1808, variant: "percentual" },
    { indicador: "ROIC", valor: 0.1954, variant: "percentual" },
    { indicador: "ROA", valor: 0.015, variant: "percentual" },
    { indicador: "Patrimônio / Ativos", valor: 0.08 },
    { indicador: "Passivos / Ativos", valor: 0.92 },
    { indicador: "Liquidez Corrente", valor: 9.06 },
    { indicador: "CAGR Receitas 5 Anos", valor: 0.1566, variant: "percentual" },
    { indicador: "CAGR Lucros 5 Anos", valor: 0.131, variant: "percentual" },
  ];

  let sxColumns = {
    xs: "repeat(2, 1fr)",
    sm: "repeat(3, 1fr)",
    md: "repeat(4, 1fr)",
    lg: "repeat(6, 1fr)",
  };

  return (
    <Stack spacing={2} sx={{ py: 2 }}>
      <Stack>
        <Typography variant="h6" color="textPrimary">
          Indicadores Fundamentalista {ativo.ticker}
        </Typography>
      </Stack>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: sxColumns,
          gap: 1.5,
        }}
      >
        {indicadoresFinanceiros.map(({ indicador, valor, variant }) => {
          return (
            <CardInfo
              key={crypto.randomUUID()}
              label={indicador}
              value={valor}
              //subValue
              valueProps={{
                variant: "h6",
              }}
              // helpText={`Atualizado em ${formats.formatDate(cotacao?.hoje)}`}
              variant={variant}
              copy={"muted"}
            />
          );
        })}
      </Box>
    </Stack>
  );
});

export default AtivoIndicadores;
